import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getCategories = () => httpClient.get(`${ENDPOINT_API.CATEGORIES}`);

export {
	getCategories,
};
